<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :loading="loading"
    hide-actions
    :select-all="selectable"
    v-bind="$attrs"
    item-key="culture_id"
    v-model="selected"
    class="elevation-1 list-culture--table">
    <template v-slot:items="props">
      <tr :class="{'amber lighten-3': props.item.status === 'invalid'}">
        <td v-if="selectable">
          <v-checkbox
            v-model="props.selected"
            primary
            hide-details
          ></v-checkbox>
        </td>
        <td style="width: 80px;">{{props.item.culture_id}}</td>
        <td class="text-xs-left">
          {{props.item.inoculation_date}}
        </td>
        <td class="text-xs-left" v-for="n in ['genus', 'species', 'strain']" :key="n">
          <span v-if="props.item.taxonomy.length && props.item.taxonomy[0]">
            {{props.item.taxonomy[0].tax[n]}}
          </span>
          <span v-else>
            "N/A"
          </span>
        </td>
        <td class="text-xs-left">
          <span v-if="props.item.organization">{{props.item.organization.name}}</span>
        </td>
        <td class="text-xs-left">
          <span  v-if="props.item.researcher">{{props.item.researcher.first_name}}</span>
        </td>
        <td class="text-xs-left">
          <span v-if="props.item.experiment_class">{{props.item.experiment_class.name}}</span>
        </td>
        <td class="text-xs-left">
          <span v-if="props.item.culture_medium">{{props.item.culture_medium.name}}</span>
        </td>
        <td class="text-xs-left">
          {{props.item.fermentation_volume}}
        </td>
        <td class="text-xs-left">
          {{props.item.fermentation_temperature}}
        </td>
        <td class="justify-center layout px-0" v-if="actions">
          <slot name="actions" v-bind:item="props.item">

          </slot>
        </td>

      </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: ['items', 'loading', 'selectable', 'actions', 'value'],
  computed: {
    headers () {
      const fields = [
        'Culture ID',
        'Produced Date',
        'Genus',
        'Species',
        'Strain',
        'Organization',
        'Researcher',
        'Experiment Class',
        'Media',
        'Fermentation Vol',
        'Fermentation Temp'
      ]
      if (this.actions) {
        fields.push('Action')
      }
      return fields.map((f) => ({text: f, value: f, sortable: false}))
    }
  },
  data () {
    return {
      selected: []
    }
  },
  created () {
    this.selected = this.value
  },
  watch: {
    selected () {
      this.$emit('input', this.selected)
    },
    value () {
      this.selected = this.value
    }
  }
}
</script>

<style>

</style>
